
import React from "react";
import FormField from "@/components/forms/FormField";

interface SocialMediaSectionProps {
  facebook: string;
  instagram: string;
  tiktok: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  formErrors: Record<string, string>;
  displayMode?: boolean; // New prop to determine if we're in display or edit mode
}

const SocialMediaSection: React.FC<SocialMediaSectionProps> = ({
  facebook,
  instagram,
  tiktok,
  handleChange,
  formErrors,
  displayMode = false, // Default to form mode
}) => {
  // Check if any social media links exist
  const hasSocialMedia = facebook || instagram || tiktok;
  
  // If in display mode and no social media links, don't render anything
  if (displayMode && !hasSocialMedia) {
    return null;
  }
  
  // In form mode, always show the section for input purposes
  // In display mode with social media links, show the section
  return (
    <div className="border-t pt-6 mt-6">
      <h3 className="text-lg font-medium mb-4">Social Media</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          id="facebook"
          label="Facebook"
          type="url"
          value={facebook}
          onChange={handleChange}
          error={formErrors.facebook}
          placeholder="https://facebook.com/yourbusiness"
        />

        <FormField
          id="instagram"
          label="Instagram"
          type="url"
          value={instagram}
          onChange={handleChange}
          error={formErrors.instagram}
          placeholder="https://instagram.com/yourbusiness"
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mt-4">
        <FormField
          id="tiktok"
          label="TikTok"
          type="url"
          value={tiktok}
          onChange={handleChange}
          error={formErrors.tiktok}
          placeholder="https://tiktok.com/@yourbusiness"
        />
      </div>
    </div>
  );
};

export default SocialMediaSection;
